import type { PressedStateProps } from './pressedState';

export const pressedState = (
  selected: boolean | undefined,
): PressedStateProps => ({ 'aria-pressed': !!selected });
